// extracted by mini-css-extract-plugin
module.exports = {"use-cases":"UseCases_use-cases__YJKli","use-case-single":"UseCases_use-case-single__7l7Y_"};